import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

const MultiSelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const MultiSelectBox = styled.div`
  width: 100%;
  padding: 0.9rem 1rem;
  background: #ffffff;
  border: 1px solid rgba(0, 102, 255, 0.15);
  border-radius: 8px;
  font-size: 0.9rem;
  color: var(--text-primary);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:focus-within {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
  }
`;

const Dropdown = styled.div`
  position: absolute;
  width: 100%;
  background: white;
  border: 1px solid rgba(0, 102, 255, 0.15);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  z-index: 100;
  max-height: 180px;
  overflow-y: auto;
  margin-top: 4px;
`;

const Option = styled.label`
  display: flex;
  align-items: center;
  padding: 0.6rem 1rem;
  cursor: pointer;
  font-size: 0.9rem;
  &:hover {
    background: #f5f5f5;
  }

  input {
    margin-right: 0.5rem;
  }
`;

const Caret = styled.span`
  font-size: 0.8rem;
`;

export const MultiSelectDropdown = ({ options, selected, onChange }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleOption = (value) => {
    const newSelection = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    onChange(newSelection);
  };

  return (
    <MultiSelectWrapper ref={dropdownRef}>
      <MultiSelectBox onClick={() => setOpen((prev) => !prev)}>
        {selected.length > 0 ? selected.join(', ') : 'Select roles'}
        <Caret>▾</Caret>
      </MultiSelectBox>
      {open && (
        <Dropdown>
          {options.map((opt) => (
            <Option key={opt.value}>
              <input
                type="checkbox"
                checked={selected.includes(opt.value)}
                onChange={() => toggleOption(opt.value)}
              />
              {opt.label || opt.name}
            </Option>
          ))}
        </Dropdown>
      )}
    </MultiSelectWrapper>
  );
};
